import { useQuery } from "@tanstack/react-query";
import { UserAPI } from "../userApi";
import { TReview } from "../../interfaces/interfaces";

const getUserPreviewQueryKey = (userId?: string) => ["userPreview", userId];

export const useGetUserPreview = (
  userId?: string,
  showNotificationOnError?: boolean
) => {
  return useQuery(
    getUserPreviewQueryKey(userId),
    () => {
      return UserAPI.getUserPreview(userId!, showNotificationOnError);
    },
    {
      enabled: Boolean(userId)
    }
  );
};

// export const getUserQueryKey = (userId?: string) => ["user", userId];
// export const useGetUser = (userId?: string) => {
//   return useQuery(getUserQueryKey(userId), () => {
//       if (!userId) return;
//       return UserAPI.getUser(userId);
//     },
//     { enabled: Boolean(userId) }
//   );
// };

const getUserShortDescriptionQueryKey = (userId?: string) => [
  "userShortDescription",
  userId
];

export const useGetUserShortDescription = (
  userId?: string,
  currentUserId?: string
) => {
  return useQuery(
    getUserShortDescriptionQueryKey(userId),
    () => {
      if (!userId) {
        return null;
      }
      return UserAPI.getShortDescription([userId!]).then((response) => {
        if (response?.users_short_description?.[0]) {
          return response.users_short_description[0];
        }
        return null;
      });
    },
    {
      enabled: Boolean(userId) && Boolean(currentUserId)
    }
  );
};

export const getReviewsByHostQueryKey = ({ hostId }: { hostId?: string }) => [
  "reviews",
  hostId
];
export const useGetReviewsByHost = (
  hostId?: string,
  enabled: boolean = true,
  selectFn?: (res: TReview[]) => TReview[]
) => {
  return useQuery(
    getReviewsByHostQueryKey({ hostId }),
    () => {
      if (!hostId) return;
      return UserAPI.getReviewsByHost(hostId);
    },
    {
      enabled: Boolean(hostId) && enabled,
      select: (data) =>
        typeof selectFn === "function" && Array.isArray(data)
          ? selectFn(data)
          : data
    }
  );
};

export const getReviewsByStudentQueryKey = ({
  studentId
}: {
  studentId?: string;
}) => ["reviewsByStudent", studentId];
export const useGetReviewsByStudent = (
  studentId?: string,
  enabled: boolean = true
) => {
  return useQuery(
    getReviewsByStudentQueryKey({ studentId }),
    () => {
      if (!studentId) return;
      return UserAPI.getReviewsByStudent(studentId);
    },
    { enabled: Boolean(studentId) && enabled }
  );
};
